import { Link, Outlet } from 'react-router';
import { LogOutIcon } from 'lucide-react';

import vizitProIcon from '@/assets/brand/icon-64.png';
import { useUser } from '@/components/auth-provider';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/language-context';
import { useLogout } from '@/hooks/use-logout';

import { LangToggle } from './lang-toggle';

/**
 * Minimal shell for an employee session — one destination (their schedule),
 * so there's no sidebar/bottom-nav grid to maintain, unlike `AppLayout`.
 */
export function EmployeeLayout() {
  const { user } = useUser();
  const { t } = useLanguage();
  const handleLogout = useLogout();

  return (
    <div className="flex min-h-svh flex-col bg-background">
      <header className="flex items-center justify-between px-4 py-3 border-b bg-card sticky top-0 z-10">
        <Link to="/schedule" className="flex items-center gap-2 text-base font-bold tracking-tight">
          <img src={vizitProIcon} alt="" className="w-6 h-6 rounded-md" />
          VizitPro
          {user?.businesses[0] && (
            <span className="text-xs font-normal text-muted-foreground ml-2">
              {user.businesses[0].business_name}
            </span>
          )}
        </Link>
        <div className="flex items-center gap-2">
          {user && (
            <span className="text-xs text-muted-foreground text-right leading-tight hidden sm:block">
              <span className="block font-medium text-foreground">{user.name}</span>
              <span className="block">{user.email}</span>
            </span>
          )}
          <LangToggle />
          <Button
            variant="ghost"
            size="icon"
            className="w-8 h-8 text-muted-foreground"
            onClick={handleLogout}
            aria-label={t.signOut}
          >
            <LogOutIcon className="w-4 h-4" />
          </Button>
        </div>
      </header>

      <main className="flex-1 p-4 sm:p-6">
        <Outlet />
      </main>
    </div>
  );
}
